import styled from 'styled-components';

import { Text } from '@gympass/yoga';

export const Title = styled(Text.H4)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.light};
`;

export const WelcomeText = styled(Text.Medium)`
  color: ${({ theme }) => theme.yoga.colors.primaryLight};
  margin-top: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.light};
`;

export const AmountInfo = styled(Text.H3)`
  color: ${({ theme }) => theme.yoga.colors.primaryLight};
`;
